import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
const GlobalSelectFieldWithoutFormikNew = ({
  label,
  data,
  selectedDetails,
  setChange,
  setDirectChange,
  keys,
  sx,
  fullWidth,
  disabled = false,
  clearButton = false,
  onClear,
}) => {
  const { itemId, itemValue } = keys;
  const handleChange = (e) => {
    const selectedId = e.target.value;
    const objectIs = data.find((objects) => objects[itemId] == selectedId);
    if (setDirectChange) {
      setDirectChange({
        id: objectIs[itemId],
        value: objectIs[itemValue],
      });
    } else {
      setChange((pvs) => ({
        ...pvs,
        id: objectIs[itemId],
        value: objectIs[itemValue],
      }));
    }
  };

  return (
    <FormControl fullWidth={fullWidth} sx={sx}>
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={disabled}
        name="selectField"
        label={label}
        value={selectedDetails?.id != null ? selectedDetails.id : ''}
        onChange={handleChange}
        endAdornment={
          selectedDetails?.id != null && !disabled && clearButton ? (
            <IconButton
              size="small"
              sx={{ mr: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                onClear ? onClear() : setChange({});
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          ) : null
        }
      >
        {data?.length > 0 &&
          data?.map((item) => (
            <MenuItem key={item[itemId]} value={item[itemId]}>
              {item[itemValue]}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default GlobalSelectFieldWithoutFormikNew;
